import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import {BankFileEntryDTO} from '../models/BankFileEntryDTO';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BankFileService {
  private url = environment.baseUrl + '/bank-file';

  constructor(
    private httpClient: HttpClient,
    private datePipe: DatePipe
  ) { }

  getBankFileEntriesByPaymentIdFnb(paymentId: number): Observable<BankFileEntryDTO[]> {
    const params = new HttpParams()
      .set('paymentId', String(paymentId));
    return this.httpClient.get<BankFileEntryDTO[]>(this.url + '/fnb', {params});
  }

  getBankFileEntriesPrAuthorisationFnb(paymentId: number, paymentType: string): Observable<BankFileEntryDTO[]> {
    const params = new HttpParams()
      .set('paymentId', String(paymentId))
      .set('paymentType', String(paymentType));
    return this.httpClient.get<BankFileEntryDTO[]>(this.url + '/fnb', {params});
  }

  public generateBankFile(bankFileEntries: BankFileEntryDTO[], bankAccountNumber: string, paymentId: number) {
    const replacer = (key, value) => value === null ? '' : value;
    const keys = Object.keys(bankFileEntries[0]);
    // Add data to the top of the file
    const csv = bankFileEntries.map(row => keys.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    // Then add column headers above the data
    csv.unshift(this.createColumnHeaderFnb());
    // Then add the account number & hash total above the column headers
    csv.unshift(`${bankAccountNumber},${this.generateHashTotal(bankFileEntries)}`);
    // Then add the date above the account & number hash total
    csv.unshift(this.datePipe.transform(new Date(), 'dd-MM-yyyy'));
    // Then add the format above the date
    csv.unshift('BInSol - U ver 1.00');
    const csvArray = csv.join('\r\n');

    const blob = new Blob([csvArray], {type: 'text/csv'});
    saveAs(blob, `bank_file_${paymentId}_${this.datePipe.transform(new Date(), 'yyyyMMdd_HHmm')}.csv`);
  }

  private generateHashTotal(bankFileEntries: BankFileEntryDTO[]): number {
    let hashTotal = 0;
    bankFileEntries.forEach(entry => {
      if (entry.amount != null) {
        hashTotal += Number(entry.amount);
      }
    });
    return hashTotal;
  }

  private createColumnHeaderFnb(): string {
    return 'RECIPIENT NAME,RECIPIENT ACCOUNT,RECIPIENT ACCOUNT TYPE,BRANCHCODE,AMOUNT,OWN REFERENCE,RECIPIENT REFERENCE,EMAIL 1 NOTIFY,EMAIL 1 ADDRESS,EMAIL 1 SUBJECT,EMAIL 2 NOTIFY,EMAIL 2 ADDRESS,EMAIL 2 SUBJECT,EMAIL 3 NOTIFY,EMAIL 3 ADDRESS,EMAIL 3 SUBJECT,EMAIL 4 NOTIFY,EMAIL 4 ADDRESS,EMAIL 4 SUBJECT,EMAIL 5 NOTIFY,EMAIL 5 ADDRESS,EMAIL 5 SUBJECT,FAX 1 NOTIFY,FAX 1 CODE,FAX 1 NUMBER,FAX 1 SUBJECT,FAX 2 NOTIFY,FAX 2 CODE,FAX 2 NUMBER,FAX 2 SUBJECT,SMS 1 NOTIFY,SMS 1 CODE,SMS 1 NUMBER,SMS 2 NOTIFY,SMS 2 CODE,SMS 2 NUMBER';
  }
}
